import './media-gallery-full-screen.css';
import 'swiper/css';
import 'swiper/css/navigation';

import { useMemo } from 'react';
import { ListingPhoto } from './listing-photo';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
import { IListingPhoto } from '../../models/listing-photo.model';

import { iconClose } from '../../util/icons';

export interface MediaGalleryFullScreenProps {
  photos: IListingPhoto[];
  initialSlide: number;
  close(): void;
}

export const MediaGalleryFullScreen = (props: MediaGalleryFullScreenProps) => {

  const totalMedia = useMemo(() =>
    props.photos.length
    , [props.photos]);

  const swiper = useMemo(() =>
    <Swiper
      slidesPerView={1}
      // spaceBetween={5}
      pagination={{ "clickable": true }}
      navigation
      className="media-gallery-full-screen"
      initialSlide={props.initialSlide}
      loop={true}
      modules={[Navigation]}
    >
      {props.photos.map((photo, i) => <SwiperSlide key={i}>
        <ListingPhoto id={photo.id} description={photo.description} description2={photo.description2} url={photo.url} />
        <div className="media-number">{i + 1} of {totalMedia}</div>
        {
          photo.description !== "" &&
          <div className="media-description">{photo.description}</div>
        }
        {
          photo.description2 !== "" &&
          <div className="media-description">{photo.description2}</div>
        }
      </SwiperSlide>)}
    </Swiper>
    , [props.initialSlide, props.photos, totalMedia]);

  return (
    <div className="media-gallery-full-screen">
      {swiper}
      <div className="media-gallery-full-screen-close-button-div">
        <button onClick={props.close} className="close-button">{iconClose} Close</button>
      </div>
    </div>
  );
}
